import React, { PropTypes } from 'react';
import classNames from 'classnames';
import Images from './Images';
import Actu from './Actu';
import VideoSlide from './VideoSlide';
import { trIn, findImagesPosition, isCarousel } from '../utils';

const Interligne = () => (<div className="interligne"><span className="tiret"></span></div>);

const Article = ({ item, lang, isLast }) => (
  <article
    className={classNames({
      wow: !isCarousel(item),
      flipInY: !isCarousel(item),
      animated: !isCarousel(item),
    })}
  >
    <div
      className={classNames(
        'bloc-article',
        { actus: item.has('actus') }
      )}
      id={item.get('title')}
    >
      {item.has('actus') ||
        <Images
          item={item}
          lang={lang}
          position={findImagesPosition(item)}
          carousel={isCarousel(item)}
        />}
      {item.get('actus', []).map((actus, i) =>
        <Actu
          key={i}
          lang={lang}
          items={actus}
          title={trIn(item, 'title', lang)}
        />)}
      {item.has('video') && <VideoSlide lang={lang} item={item} />}
    </div>
    {isLast || <Interligne />}
  </article>
);

Article.propTypes = {
  lang: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired,
};

export default Article;



// WEBPACK FOOTER //
// ./common/components/Article.js